import { all } from 'redux-saga/effects';

import adjustSlotQty from './adjustSlotQty.saga';
import acknowledgePickTour from './acknowledgePickTour.saga';
import createPickTour from './createPickTour.saga';
import forwardOrders from './forwardOrders.saga';
import getPickTourItems from './getPickTourItems.saga';
import getExternalConfig from './getExternalConfig.saga';
import getOrders from './getOrders.saga';
import getPickTours from './getPickTours.saga';
import getRecallOrders from './getRecallOrders.saga';
import getCompletedRecallTours from './getCompletedRecallTours.saga';
import getCompletedEPTours from './getCompletedEPTours.saga';
import getProximityStore from './getProximityStore.saga';
import getEmployeeMetadata from './getEmployeeMetadata.saga';
import logToast from './logToast.saga';
import skipPickTour from './skipPickTour.saga';
import updatePickTourItem from './updatePickTourItem.saga';
import updatePickTour from './updatePickTour.saga';
import resetPickTour from './resetPickTour.saga';
import retryOrder from './retryOrder.saga';
import printPickList from './printPickList.saga';
import printLocationReport from './printLocationReport.saga';
import rePrintEPLabel from './rePrintEPLabel.saga';
import printDiscrepancyReport from './printDiscrepancyReport.saga';
import printRecallReport from './printRecallReport.saga';
import driverLogoff from './driverLogoff.saga';
import sendLogSaga from './log.saga';
import getMobilePrinterList from './getMobilePrinterList.saga';

export default function* RootSaga() {
  yield all([
    adjustSlotQty(),
    acknowledgePickTour(),
    createPickTour(),
    forwardOrders(),
    getPickTourItems(),
    getExternalConfig(),
    getOrders(),
    getPickTours(),
    getRecallOrders(),
    getCompletedRecallTours(),
    getCompletedEPTours(),
    getProximityStore(),
    getEmployeeMetadata(),
    logToast(),
    skipPickTour(),
    updatePickTourItem(),
    updatePickTour(),
    resetPickTour(),
    retryOrder(),
    printPickList(),
    printLocationReport(),
    rePrintEPLabel(),
    printDiscrepancyReport(),
    printRecallReport(),
    driverLogoff(),
    sendLogSaga(),
    getMobilePrinterList(),
  ]);
}
